export const bookingsMixin = {
    props: {
        booking: Object
    },
    computed: {
        isEnquiry: function() {
            const state = String(this.booking.state);
            return state === 'enquiry';
        },
        isNoContactDetails: function() {
            const communicationState = String(this.booking.communicationState);
            return communicationState === 'no-guest-contact-details';
        },
        isMigrating: function() {
            const state = String(this.booking.state);
            return state === 'migrating';
        },
        isActive: function() {
            const state = String(this.booking.state);
            return state === 'active';
        },
        isRequestingAmendment: function() {
            const state = String(this.booking.state);
            return state === 'requesting-amendment';
        },
        isManuallyUpdating: function() {
            const state = String(this.booking.state);
            return state === 'manually-updating';
        },
        isCancelled: function() {
            return this.isBookingCancelled(this.booking);
        },
        isBlockOut: function() {
            const state = String(this.booking.state);
            return state === 'block-out';
        },
        tooltipTextForStateForBooking: function() {
            if (this.isNoContactDetails) {
                return "No email address";
            }
            switch (this.booking.state) {
                case 'enquiry':
                    return "Enquiry";
                case 'active':
                    return "Active";
                case 'requesting-amendment':
                    return "Guest has requested an amendment. Please check your email.";
                case 'cancelled':
                    return "Cancelled";
                case 'block-out':
                    return "Block out";
            }
            return '';
        }
    },
    methods: {
        isBookingCancelled: function(booking) {
            const state = String(booking.state);
            return state === 'cancelled';
        },
        isBookingRequestingAmendment: function(booking) {
            const state = String(booking.state);
            return state === 'requesting-amendment';
        },
        getTotalGuestsForBooking: function(booking) {
            if (!booking || !booking.rooms) {
                return 0;
            }
            return booking.rooms.reduce((accumulator, room) => accumulator + room.numberOfAdults + room.numberOfChildren1 + room.numberOfChildren2, 0);
        }
    },
};